import React from "react";
import { Button, Modal, Tooltip, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { RubricList } from "../FU-61/RubricList";
import { isNullOrSpace } from "../Common/Utils";

interface Props {
  width?: number;
  label?: string;
  groupCreationRequiredFlag?: string;
  scoringType?: string;
  onChange?: (value: any) => void;
}

export const RubricSelecter = ({
  width = 200,
  label,
  groupCreationRequiredFlag,
  scoringType,
  onChange,
}: Props) => {
  const [visible, setVisible] = React.useState(false);

  const onSelect = (newValue: any) => {
    onChange?.(newValue);
    setVisible(false);
  };

  const onSearchClick = (event) => {
    setVisible(true);
  };

  return (
    <>
      <Tooltip title={label}>
        <Space size={1}>
          {/* <Input
            disabled={true}
            value={label}
            style={{ width: width }}
            allowClear={true}
          /> */}
          <Button
            type="default"
            style={{
              width: width,
            }}
            onClick={onSearchClick}
          >
            <span className="buttontext">
              {isNullOrSpace(label) ? "　" : label}
            </span>
          </Button>
          <Button onClick={onSearchClick}>
            <span className="buttontext">
              <SearchOutlined />
            </span>
          </Button>
        </Space>
      </Tooltip>
      <Modal
        title="ﾙｰﾌﾞﾘｯｸ選択"
        maskClosable={false}
        centered
        visible={visible}
        onCancel={() => setVisible(false)}
        width={1200}
        footer={null}
      >
        <RubricList
          isPopup={true}
          groupCreationRequiredFlag={groupCreationRequiredFlag}
          scoringType={scoringType}
          onSelect={onSelect}
        />
      </Modal>
    </>
  );
};
